var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 4.5V3.75H6.06266L9.08766 7.53125C9.19416 7.66427 9.25219 7.8296 9.25219 8C9.25219 8.1704 9.19416 8.33573 9.08766 8.46875L6.06266 12.25H11.7502V11.5C11.7502 11.3011 11.8292 11.1103 11.9698 10.9697C12.1105 10.829 12.3012 10.75 12.5002 10.75C12.6991 10.75 12.8898 10.829 13.0305 10.9697C13.1711 11.1103 13.2502 11.3011 13.2502 11.5V13C13.2502 13.1989 13.1711 13.3897 13.0305 13.5303C12.8898 13.671 12.6991 13.75 12.5002 13.75H4.50016C4.35884 13.75 4.2204 13.7101 4.10077 13.6349C3.98114 13.5597 3.8852 13.4522 3.82399 13.3248C3.76279 13.1975 3.73882 13.0554 3.75483 12.915C3.77085 12.7746 3.82621 12.6416 3.91453 12.5312L7.53953 8L3.91453 3.46875C3.82621 3.35844 3.77085 3.22542 3.75483 3.08502C3.73882 2.94461 3.76279 2.80254 3.82399 2.67517C3.8852 2.5478 3.98114 2.44031 4.10077 2.36509C4.2204 2.28987 4.35884 2.24997 4.50016 2.25H12.5002C12.6991 2.25 12.8898 2.32902 13.0305 2.46967C13.1711 2.61032 13.2502 2.80109 13.2502 3V4.5C13.2502 4.69891 13.1711 4.88968 13.0305 5.03033C12.8898 5.17098 12.6991 5.25 12.5002 5.25C12.3012 5.25 12.1105 5.17098 11.9698 5.03033C11.8292 4.88968 11.7502 4.69891 11.7502 4.5Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/Sigma.d80ce1919ac720ccd3e73a670fc077c3.svg";
export { ForwardRef as ReactComponent };